import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import React, {useEffect, useState} from "react";
import MyBreadcrumbs from "components/MyBreadcrumbs";
import cn from "clsx";
import Link from "next/link";
import MyList from "components/MyList";
import {wrapper} from "lib/store";
import {useRouter} from "next/router";
import BrandCard from "components/cards/BrandCard";
import {useDispatch, useSelector} from "react-redux";
import {getPaginatedBrandsThunk} from "lib/features/brandSlice";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";

import config from '../../../data/config.json'
import {checkMobile} from "../../../utils/helper";

const BRANDS_ROUTE = config.brand.route
const SORT_OPTIONS = config.brand.sort

const BREAD_ROUTE = [
    {label: 'Home', href: '/', isActive: false},
    {label: 'brands_service_brands', href: '/services', isActive: true},
]

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
    const {
        query,locale,
    } = context
    let page = 1
    let sort = {}
    let businessTypes = []
    const filter = {
        businessTypes
    }

    return {
        props: {
            page, sort,
            ...(await serverSideTranslations(locale, ['home', 'common']))
        }
    }
})

export default function Services(props) {
    const router = useRouter()
    const {
        page: _page,
        sort: _sort,
    } = props
    const brands = useSelector(state => state.brand.brands)
    const [localBrands, setLocalBrands] = useState(brands)
    const [sort, setSort] = useState(SORT_OPTIONS.find(s => s.sort.sortBy === _sort.sortBy && s.sort.order === _sort.order) || SORT_OPTIONS[0])
    const dispatch = useDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        console.log('filtering service brand: ', brands.length)
        setLocalBrands(brands.filter(item => item.bizType === 'SERVICE'))
    }, [])

    const [loaded, setLoaded] = useState(false)
    async function initBrand() {
        const sort = {}
        const page = 1
        const filter = {}
        await dispatch(getPaginatedBrandsThunk({page, filter, sort}))
    }
    useEffect(() => {
        console.log('at services brands: ', brands.length)
        if (brands[0].name === 'Test') {
            initBrand()
        } else {
            setLocalBrands(brands.filter(item => item.bizType === 'SERVICE'))
            setLoaded(true)
        }
        return () => {
            console.log('clean up initBrand')
        }
    }, [brands])

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        if (loaded) {
            setIsMobile(checkMobile())
        }
    }, [loaded])

    return (
        <Wrapper>
            <div style={{ width: '100%', borderBottom: 'solid thin #DDDDDD' }}>
                <Container>
                    <MyBreadcrumbs t={t} routeList={BREAD_ROUTE}/>
                    <nav className={isMobile ? cn('flex', 'grow', 'shrink', 'min-w-0', 'overflow-scroll', 'mt-10') : cn('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden')}>
                        {
                            BRANDS_ROUTE.map(route => {
                                return (
                                    <Link href={route.href} key={route.label}>
                                        <a style={{ fontSize: 14, fontWeight: router.pathname === route.href ? 600 : 400,
                                            borderBottom: router.pathname === route.href ? 'solid 2px #108085' : 'unset'
                                        }}  className={isMobile ?
                                            cn(
                                                'font-normal', 'mr-7', 'last:mr-0', 'leading-5',
                                            ) :
                                            cn(
                                                'font-normal', 'mr-7', 'last:mr-0', 'leading-10',
                                            )}>
                                            {t(`home:${route.label}`)}
                                        </a>
                                    </Link>
                                )
                            })

                        }
                    </nav>
                </Container>
            </div>
            {
                loaded ?
                    <Container>
                        <MyList t={t} itemComponent={BrandCard} dataList={localBrands} title={t('home:brands_service_brands')} sort={sort} setSort={setSort} SORT_OPTIONS={SORT_OPTIONS} showSearchAndSort={true} />
                    </Container> :
                    <Container style={{ marginTop: 50 }}>
                        <span>{t('home:loading')}</span>
                    </Container>
            }
        </Wrapper>
    )
}

Services.getLayout = function getLayout(page) {
    return (
        <DefaultLayout>
            {page}
        </DefaultLayout>
    )
}
